import React, { Component } from "react";
import {
  Grid,
  Header,
  Button,
  Form,
  Input,
  Transition
} from "semantic-ui-react";
import classNames from "classnames";
import axios from "axios";
import { Config } from "../../../data/config";
import { connect } from "react-redux";
import { getFormattedErrors, phoneMask } from "../../../util";

class Step1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      animation: props.animation,
      first_name: "",
      last_name: "",
      email: "",
      building_qualify: false,
      phone: "",
      address: props.connection.address,
      errors: {},
      serverErrors: {},
      submitted: false
    };
    this.transitionBack = this.transitionBack.bind(this);
    this.transitionNext = this.transitionNext.bind(this);
    this.onChange = this.onChange.bind(this);
    this.firstName = React.createRef();
    this.phone = null;
  }

  componentDidMount() {
    this.setState({
      visible: true
    });
    setTimeout(() => {
      phoneMask(this.phone.inputRef);
    })
    
  }

  transitionBack() {
    const { setServiceAvailable } = this.props;

    this.setState({
      animation: "fade left",
      visible: !this.state.visible
    });
    setTimeout(() => {
      setServiceAvailable(null, "fade right");
    }, 400);
  }

  validate() {
    const errors = {};
    const { first_name, last_name, email, address } = this.state;
    if (!first_name) {
      errors["first_name"] = "First name is required";
    }
    if (!last_name) {
      errors["last_name"] = "Last name is required";
    }
    if (!email) {
      errors["email"] = "Email is required";
    }
    if (!address) {
      errors["address"] = "Address is required";
    }
    return errors;
  }

  onChange(e, data) {
    this.setState({
      [data.name]: data.type === "checkbox" ? data.checked : data.value
    });
  }

  nextStep() {
    const { changeStep } = this.props;

    this.setState({
      animation: "fade right",
      visible: false
    });

    setTimeout(() => {
      changeStep(6, "fade left");
    }, 400);
  }

  getData() {
    const { connection } = this.props;

    return {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      building_qualify: this.state.building_qualify,
      phone: this.state.phone,
      address: this.state.address,
      postal_code: connection.postalCode,
      unit: connection.unitNo
    };
  }

  transitionNext() {
    const errors = this.validate();
    if (Object.keys(errors).length) {
      this.setState({
        errors: errors
      });
    } else {
      this.setState({
        submitted: true,
        errors: {}
      });
      axios
        .post(`${Config.frontApiUrl}/availability/waitinglist`, this.getData())
        .then(response => {
          this.nextStep();
        })
        .catch(error => {
          const errors = getFormattedErrors(error.response.data.error) || {};
          this.setState({
            serverErrors: errors,
            submitted: false
          });
        });
    }
  }

  render() {
    const {
      visible,
      animation,
      errors,
      address,
      serverErrors,
      submitted
    } = this.state;

    return (
      <div>
        {this.props.setServiceAvailable && (
          <div className="back--icon" onClick={this.transitionBack} />
        )}
        <Transition visible={visible} duration={500} animation={animation}>
          <div>
            <Header className="title__main" as="h1" textAlign="center">
              Request FibreStream
            </Header>
            <Header.Subheader className="text-black">
              Service is not yet available. Enter your info to request service
              in your building.
            </Header.Subheader>

            <Grid className="form__signup width__xs">
              <Grid.Row className="py-0">
                <Grid.Column className="px-0">
                  <Form>
                    <Form.Group widths="equal">
                      <Form.Field
                        className={classNames({
                          "is-error": errors.first_name
                        })}
                      >
                        <Input
                          placeholder="First Name"
                          name="first_name"
                          ref={this.firstName}
                          onChange={this.onChange}
                          {...errors.first_name && {
                            color: "red",
                            icon: "exclamation triangle"
                          }}
                          labelPosition="right"
                          label={
                            <div className="label__text">
                              First Name
                            </div>
                          }
                        />
                        {errors.first_name && (
                          <div className="error-text">{errors.first_name}</div>
                        )}
                      </Form.Field>
                      <Form.Field
                        className={classNames({ "is-error": errors.last_name }, "mt-0")}
                      >
                        <Input
                          placeholder="Last Name"
                          name="last_name"
                          onChange={this.onChange}
                          {...errors.last_name && {
                            color: "red",
                            icon: "exclamation triangle"
                          }}
                          labelPosition="right"
                          label={
                            <div className="label__text">
                              Last Name
                            </div>
                          }
                        />
                        {errors.last_name && (
                          <div className="error-text">{errors.last_name}</div>
                        )}
                      </Form.Field>
                    </Form.Group>
                    <Form.Field
                      className={classNames({ "is-error": errors.address })}
                    >
                      <Input
                        placeholder="Address"
                        name="address"
                        onChange={this.onChange}
                        {...errors.address && {
                          color: "red",
                          icon: "exclamation triangle"
                        }}
                        labelPosition="right"
                        label={
                          <div className="label__text">Address</div>
                        }
                        defaultValue={address}
                      />
                      {errors.address && (
                        <div className="error-text">{errors.address}</div>
                      )}
                    </Form.Field>
                    <Form.Field
                      className={classNames({ "is-error": errors.email })}
                    >
                      <Input
                        placeholder="Email"
                        type="email"
                        name="email"
                        onChange={this.onChange}
                        {...errors.email && {
                          color: "red",
                          icon: "exclamation triangle"
                        }}
                        labelPosition="right"
                        label={
                          <div className="label__text">Email</div>
                        }
                      />
                      {errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}
                    </Form.Field>
                    <Form.Field>
                      <Input
                        placeholder="Phone"
                        name="phone"
                        type="tel"
                        onChange={this.onChange}
                        labelPosition="right"
                        label={
                          <div className="label__text">Phone</div>
                        }
                        ref={(ref) => this.phone = ref}
                      />
                    </Form.Field>

                    {Object.keys(serverErrors).length > 0 && (
                      <div className="field is-error radius--full">
                        {serverErrors.code === 422 ? (
                          Object.keys(serverErrors.fields).map(value => (
                            <div className="error-text" key={value}>
                              {serverErrors.fields[value]}
                            </div>
                          ))
                        ) : (
                          <div className="error-text">
                            {serverErrors.message}
                          </div>
                        )}
                      </div>
                    )}

                    <Button
                      size="medium"
                      className="btn--full"
                      onClick={this.transitionNext}
                      disabled={submitted}
                    >
                      {submitted ? "Sending..." : "Send Request"}
                    </Button>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
        </Transition>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    connection: state.connection
  };
};

export default connect(mapStateToProps)(Step1);



// WEBPACK FOOTER //
// ./src/components/check-availability/service-not-available/Step1.js